import { Providers } from './providers/ReactQueryProvider';
import { AuthProvider } from './contexts/AuthContext';
import { AppRoutes } from './routes/AppRoutes';

function App() {
  return (
    <Providers>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Providers>
  );
}

export default App;
